import React from 'react';
import css from './NoteIcon.css';
import Icon from 'SF/MaterialIcon';
import PropTypes from 'prop-types';

export default class NoteIcon extends React.Component {

  get class() {
    return ` ${this.props.isMobile ? css['note-icon-mobile'] : css['note-icon']} `;
  }
  render() {
    return <Icon icon="note_add" aria-label="Has comment" className={this.class} />;
  }
}

NoteIcon.propTypes =  {
    isMobile: PropTypes.bool.isRequired
}
